import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { UseCase } from "../../base/use-case";
import { JobsRepository } from "../../repositories";
import { UpdateHdJobRequest } from '../../domain/requests/jobs/update-hd-job-request';

@Injectable({ providedIn: 'root' })
export class UpdateHdJobUsecase implements UseCase<UpdateHdJobRequest, boolean> {

  constructor(private jobRepository: JobsRepository) {
  }

  execute(params: UpdateHdJobRequest): Observable<boolean> {
    return this.jobRepository.updateHdJob(params);
  }

}
